import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { IonRouterOutlet, Platform } from '@ionic/angular';

import { StoreService } from './services/store.service';
import { NavService } from './services/nav.service';
import { UserService } from './services/user.service';
import { UiService } from './models/ui-service';
import { Ui } from './services/ui.service';
import { CommonMessageService } from './services/common-message.service';
import { TranslateService } from '@ngx-translate/core';

import { App } from '@capacitor/app';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  toggle = 'SYSTEM';

  // public appPages = [
  //   {
  //     title: 'Tableau de bord',
  //     url: '/dash',
  //     icon: 'home'
  //   },
  //   {
  //     title: 'Parametrage',
  //     url: '/settings',
  //     icon: 'settings'
  //   },
  //   {
  //     title: 'Utilisateurs',
  //     url: '/users',
  //     icon: 'people'
  //   },
  //   {
  //     title: 'Offre et Promo',
  //     url: '/offers-promo',
  //     icon: 'gift'
  //   },
  //   {
  //     title: 'Notifications',
  //     url: '/push-notifications',
  //     icon: 'send'
  //   }, {
  //     title: 'Publicité',
  //     url: '/ads',
  //     icon: 'jet'
  //   }
  // ];
  // appPages: UiService[];
  loaded = false;
  language = 'en';

  constructor(
    private platform: Platform,
    private store: StoreService,
    private helper: CommonMessageService,
    public navService: NavService,
    public translate: TranslateService,
    public ui: Ui,
    public userService: UserService,
    private userIdle: UserIdleService
  ) {
    // this.appPages = ui.services.filter(e => ui.hasPermission(e));
    this.initializeApp();
  }
  ngOnInit(): void {
    // this.language = this.store.data.language || 'eng';
  }
  ngOnDestroy(): void {
    this.userIdle.stopWatching();
  }
  async ngAfterViewInit() {
    console.log('routerOutlet;;;;', this.routerOutlet, this.store.data);
    this.navService.routerOutlet = this.routerOutlet;
    if (!this.store.isLoaded) {
      await this.store.load();
    }
    console.log('routerOutlet;;;;', this.store.data);
    this.language = this.store.data.language || 'en';
    this.initTranslate();
  }

  async initializeApp() {
    try {
      await this.store.load();
    } catch (error) {
    }
    if (this.store.data.userLogin || this.userService.currentUser) {
      console.log('Starting watching for idle');
      this.userIdle.startWatching();
      this.userIdle.onIdleStatusChanged().subscribe((v) => {
        console.log('Idle changed::', v);
      });
      this.userIdle.onTimerStart().subscribe(count => {
        console.log('count:: ', count);
      });
      // Start watch when time is up.
      this.userIdle.onTimeout().subscribe(() => {
        if (this.userService.currentUser) {
          console.log('Idle timeout');
          this.userService.logout()
        }

      });
    }
    App.addListener('appStateChange', (state) => {
      if (state.isActive && (this.store.data.userLogin || this.userService.currentUser)) {
        // check credentials
        this.userService.checkLogin();
      }
    });
    this.loaded = true;
    this.loadTheme();
    await this.platform.ready();
  }
  async logout() {
    this.userService.logout()
  }
  showThemeChoose() {
    this.helper.sheet([
      {
        text: 'System',
        role: 'ok',
        cssClass: 'tertiary',
        handler: () => {
          this.toggle = 'SYSTEM';
          this.setTheme();
        },
      }, {
        text: 'Dark',
        role: 'ok',
        cssClass: 'tertiary',
        handler: () => {
          this.toggle = 'DARK';
          this.setTheme();
        },
      }, {
        text: 'Light',
        role: 'ok',
        cssClass: 'tertiary',
        handler: () => {
          this.toggle = 'LIGHT';
          this.setTheme();
        }
      }, {
        text: 'Fermer',
        role: 'cancel'
      }
    ], 'Thème', '', false, 'ios');
  }

  loadTheme() {
    this.toggle = this.store.data.darkmode;
    this.setTheme();
  }

  async initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang(this.language);
    if (this.store.data) {

      const lang = this.store.data.language || this.translate.getBrowserLang() || 'en';
      // const lang = 'en';
      this.translate.use(lang);
    } else {
      this.translate.use(this.translate.getBrowserLang());
      this.store.setValue('language', this.translate.getBrowserLang()
      );
    }

    console.log('### ', this.translate.getBrowserLang());
  }

  async updateLanguage() {

    console.log('language', this.language);
    // window.location.reload();

    this.translate.use(this.language);
    await this.store.setValue('language', this.language);

  }
  setTheme() {
    let dark = false;
    switch (this.toggle) {
      case 'DARK':
        dark = true;
        break;
      case 'SYSTEM':
        dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        break;
    }
    this.store.setValue('darkmode', this.toggle);
    this.toggle = this.toggle;
    this.toggleDark(dark);
  }
  toggleDark(value) {
    console.log('toggle:', value);
    if (value) {
      document.body.setAttribute('data-theme', 'dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
    }
    document.body.classList.toggle('dark', value);
  }
}
